"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupPluralize = exports.pluralizeByUnit = exports.default = void 0;
/**
 * Return plural noun form
 * @param {number} n
 * @param {string} one
 * @param {string} few
 * @param {string} many
 * @returns string
 * @example
 * ```ts
 * pluralize(6, 'яблоко', 'яблока', 'яблок') -> яблок
 * ```
 */
var pluralize = function pluralize(n, one, few, many) {
  var nP100 = n % 100;
  var nP10 = n % 10;
  if (nP10 === 1 && nP100 !== 11) {
    return one;
  }
  if (nP10 >= 2 && nP10 <= 4 && (nP100 < 10 || nP100 >= 20)) {
    return few;
  }
  return many;
};
var setupPluralize = function setupPluralize(wordSet) {
  return function (n, options) {
    if (options === void 0) {
      options = {};
    }
    var _ref = options.possessive ? wordSet.slice(1) : wordSet,
      one = _ref[0],
      few = _ref[1],
      _ref$ = _ref[2],
      many = _ref$ === void 0 ? few : _ref$;
    return pluralize(n, one, few, many);
  };
};
exports.setupPluralize = setupPluralize;
var pluralizeSeconds = setupPluralize(["секунда", "секунды", "секунд"]);
var pluralizeMinutes = setupPluralize(["минута", "минуты", "минут"]);
var pluralizeHours = setupPluralize(["час", "часа", "часов"]);
var pluralizeDays = setupPluralize(["день", "дня", "дней"]);
var pluralizeMonth = setupPluralize(["месяц", "месяца", "месяцев"]);
var pluralizeYears = setupPluralize(["год", "года", "лет"]);
var pluralizeByUnit = function pluralizeByUnit(n, unit, options) {
  switch (unit) {
    case "month":
      return pluralizeMonth(n, options);
    case "year":
      return pluralizeYears(n, options);
    case "day":
      return pluralizeDays(n, options);
    case "hour":
      return pluralizeHours(n, options);
    case "minute":
      return pluralizeMinutes(n, options);
    case "second":
      return pluralizeSeconds(n, options);
    default:
      return "";
  }
};
exports.pluralizeByUnit = pluralizeByUnit;
var _default = pluralize;
exports.default = _default;